<mf-page title="Usuarios">
  <mf-row>
    <mf-grid
      #grid
      actionButtonText="Nuevo usuario"
      [apiEndpoint]="apiEndpoint"
      [columns]="columns"
      [menuItems]="menuItems"
      [initialFilters]="filters"
      [globalFilters]="globalFilters"
      [getRowClass]="getRowClass"
      (actionButtonClick)="openNewUserPopup()" />
  </mf-row>
</mf-page>
